/*const lenis = new Lenis();

lenis.on("scroll", (e) => {});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);
*/
//NAVBAR hover
$(".navbar-has-submenu").on("mouseenter mouseover", function () {
  $(".page-wrap").addClass("fade-out");
}).on('mouseleave',function(){
  $(".page-wrap").removeClass("fade-out");
});


//MULTIPLE SLIDERS
const buildSwiperSlider = sliderElm => {
  const sliderIdentifier = sliderElm.dataset.id;
  return new Swiper(`#${sliderElm.id}`, {
    //   autoHeight: true,
    // mousewheel: true,
    navigation: {
      nextEl: `.swiper-button-next-${sliderIdentifier}`,
      prevEl: `.swiper-button-prev-${sliderIdentifier}`,
    },
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
      pauseOnMouseEnter:true
    },
    loop: true,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1.2,
      },
      // when window width is >= 480px
      767: {
        slidesPerView: 3.2,
      },
      // when window width is >= 640px
      991: {
        slidesPerView: 4.5,
      },
      1280: {
        slidesPerView: 6.5,
      }
    },
  });
}

const allSliders = document.querySelectorAll('.seller-slider');
allSliders.forEach(slider => buildSwiperSlider(slider));

//CARD SLIDER

const sellerSlider = new Swiper(".card-slider", {
  //   autoHeight: true,
  // mousewheel: true,
  navigation: {
    nextEl: ".seller-slider-arrow-right",
    prevEl: ".seller-slider-arrow-left",
  },
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
    pauseOnMouseEnter:true
  },
  loop: true,
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1.2,
    },
    // when window width is >= 480px
    767: {
      slidesPerView: 2.2,
    },
    // when window width is >= 640px
    991: {
      slidesPerView: 3.5,
    },
    1280: {
      slidesPerView: 4.5,
    }
  },
});

// SELLER SLIDER
/*
const sellerSlider = new Swiper(".seller-slider", {
  //   autoHeight: true,
  // mousewheel: true,
  navigation: {
    nextEl: ".seller-slider-arrow-right",
    prevEl: ".seller-slider-arrow-left",
  },
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
    pauseOnMouseEnter:true
  },
  loop: true,
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1.2,
    },
    // when window width is >= 480px
    767: {
      slidesPerView: 3.2,
    },
    // when window width is >= 640px
    991: {
      slidesPerView: 4.5,
    },
    1280: {
      slidesPerView: 6.5,
    }
  },
});
*/
//REVIEW MAUAL SLIDER
const testimonialSlider = new Swiper(".manual-testimonials", {

  grabCursor: true,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
  },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1.2,
    },
    // when window width is >= 480px
    767: {
      slidesPerView: 1.5,
    },
    // when window width is >= 640px
    991: {
      slidesPerView: 2,
    },
  },
});


//REVIEW SLIDER
const reviewSlider = new Swiper(".review-feefo", {
  //   autoHeight: true,
  // mousewheel: true,
  grabCursor: true,
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
  },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1.2,
    },
    // when window width is >= 480px
    767: {
      slidesPerView: 2.2,
    },
    // when window width is >= 640px
    991: {
      slidesPerView: 4.5,
    },
  },
});

//HAMPER
$(document).ready(function () {
  $(".popup").removeClass("hide");
});

$("[popup-close]").on("click", function () {
  $(".popup").removeClass("active");
  $(".popup").addClass("hide");
});

//BASKET
// $(".basket-trigger").on("click", function () {
//   $('body').addClass('cartShow');
// });
// $(".cart-arrow_holder").on("click", function () {
//   $(".cart-wrap").removeClass("show");
//   $(".cart-overlay").removeClass("show");
//   lenis.start();
// });
$(".cart-overlay").on("click", function () {
  // $(".cart-wrap").removeClass("show");
  $('body').removeClass('cartShow');
  /* lenis.start(); */
});
//FILTER ACCORDION
// $(".accordion-filter_top").on("click", function () {
//   $(this).siblings(".accordion-filter_bot").toggleClass("grid-reveal");
// });

$(document).on("click",".accordion-filter_top",function() {
  $(this).siblings(".accordion-filter_bot").toggleClass("grid-reveal");
  $(this).find(".filter-plus").toggleClass("active");
});

//ACCORDION PLUS
// $(".accordion-filter_top").each(function () {
//   $(this).on("click", function () {
//     $(this).find(".filter-plus").toggleClass("active");
//   });
// });




//FILTER BUTTONS
$(".filter-btn").on("click", function () {
  if ($(this).hasClass("is-active-filter")) {
    $(this).removeClass("is-active-filter");
  } else {
    $(this).addClass("is-active-filter");
  }
});
//DESKTOP NAV SHRINK
let dmm = gsap.matchMedia();
dmm.add("(min-width: 768px)", () => {
  let navShrink = gsap.timeline({
    scrollTrigger: {
      trigger: ".page-wrap",
      start: "top top",
      end: "+=9999",
      scrub: true,
      onUpdate: (self) => {
        if (self.direction === 1) {
          $(".nav").addClass("scrolled");
        } else {
          $(".nav").removeClass("scrolled");
        }
      },
    },
  });

  //   navShrink.fromTo(
  //     ".logo-text",
  //     {
  //       clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
  //     },
  //     {
  //       clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
  //     },
  //   ),
  //     "<";
  //   navShrink.to(
  //     ".logo-icon",
  //     {
  //       scale: "0.5",
  //     },
  //     "<",
  //   );
});

// CMS LIST SYNC POWER-UP
window.addEventListener("DOMContentLoaded", (event) => {
  // attribute value checker
  function attr(defaultVal, attrVal) {
    const defaultValType = typeof defaultVal;
    if (typeof attrVal !== "string" || attrVal.trim() === "") return defaultVal;
    if (attrVal === "true" && defaultValType === "boolean") return true;
    if (attrVal === "false" && defaultValType === "boolean") return false;
    if (isNaN(attrVal) && defaultValType === "string") return attrVal;
    if (!isNaN(attrVal) && defaultValType === "number") return +attrVal;
    return defaultVal;
  }
  // cms list sync component
  $("[tr-listsync-element='component']").each(function (index) {
    let componentEl = $(this),
      cmsListEl = componentEl.find("[tr-listsync-element='list']"),
      cmsItemEl = cmsListEl.children(),
      prevButtonEl = componentEl.find("[tr-listsync-element='button-prev']"),
      nextButtonEl = componentEl.find("[tr-listsync-element='button-next']");
    let onLoadSetting = attr(false, componentEl.attr("tr-listsync-onload")),
      activeIndexSetting = attr(0, componentEl.attr("tr-listsync-activeindex")),
      activeClassSetting = attr(
        "is-active",
        componentEl.attr("tr-listsync-activeclass"),
      );
    function addActive(trigger) {
      cmsItemEl.removeClass(activeClassSetting);
      let itemIndex = trigger.index();
      cmsListEl.each(function () {
        $(this).children().eq(itemIndex).addClass(activeClassSetting);
      });
    }
    if (onLoadSetting) addActive(cmsItemEl.eq(activeIndexSetting));
    cmsListEl.each(function () {
      let childrenItemEl = $(this).children(),
        clickSetting = attr(true, $(this).attr("tr-listsync-click")),
        hoverInSetting = attr(false, $(this).attr("tr-listsync-hoverin")),
        hoverOutSetting = attr(false, $(this).attr("tr-listsync-hoverout"));
      if (clickSetting) {
        childrenItemEl.on("click", function () {
          addActive($(this));
        });
      }
      if (hoverInSetting) {
        childrenItemEl.on("mouseenter", function () {
          addActive($(this));
        });
      }
      if (hoverOutSetting) {
        childrenItemEl.on("mouseleave", function () {
          cmsItemEl.removeClass(activeClassSetting);
        });
      }
    });
    prevButtonEl.on("click", function () {
      cmsListEl.each(function (index) {
        let childrenItemEl = $(this).children();
        let currentItemEl = childrenItemEl
          .filter("." + activeClassSetting)
          .removeClass(activeClassSetting);
        let prevItemEl = currentItemEl.prev();
        if (prevItemEl.length === 0) prevItemEl = childrenItemEl.last();
        prevItemEl.addClass(activeClassSetting);
      });
    });
    nextButtonEl.on("click", function () {
      cmsListEl.each(function (index) {
        let childrenItemEl = $(this).children();
        let currentItemEl = childrenItemEl
          .filter("." + activeClassSetting)
          .removeClass(activeClassSetting);
        let nextItemEl = currentItemEl.next();
        if (nextItemEl.length === 0) nextItemEl = childrenItemEl.first();
        nextItemEl.addClass(activeClassSetting);
      });
    });
  });
});

// create
let mm = gsap.matchMedia();

mm.add("(max-width: 767px)", () => {
  $(".footer-link_wrap").on("click", function () {
    if ($(this).hasClass("open")) {
      $(this).toggleClass("open");
      $(this).find(".footer-link_dropdown").slideToggle();
    } else {
      $(".footer-link_wrap.open").find(".footer-link_dropdown").slideUp();
      $(".footer-link_wrap.open").removeClass("open");
      $(this).addClass("open");
      $(this).find(".footer-link_dropdown").slideDown();
    }
  });
  $("body").on("click",".collection-filter_btn", function () {
    $(".sticky-filter").addClass("show");
  });
  $(".filter-close_holder").on("click", function () {
    $(".sticky-filter").removeClass("show");
  });
  $(".bottom-button-apply").on("click", function (e) {
    e.preventDefault();
    $(".sticky-filter").removeClass("show");
  });
});

// //MOBILE MENU
let menuIcon = $(".menu-icon_holder");
let menuWrap = $(".mobile-menu");
let menuOverlay = $(".menu-overlay");
let menuPanels = $(".menu_panel");
let content = $(".menu_content");
let lines = $(".nav_button_line");
let backButton = $(".go-back");
let closeMenu = $(".menu-close_holder");
let previouslyFocused;
let active;

let showSubMenu = gsap.timeline({
  paused: true,
  onComplete: () => {
    active.find("a").first().focus();
  },
  onReverseComplete: () => {
    previouslyFocused.focus();
  },
});
showSubMenu.to(menuPanels, { x: "-100%", ease: "power1.inOut", duration: 0.4 });

let showMainMenu = gsap.timeline({
  paused: true,
  defaults: { duration: 0.3 },
  onReverseComplete: () => {
    showSubMenu.progress(0);
    showSubMenu.pause();
  },
  onComplete: () => {
    menuWrap.find("button").first().focus();
  },
});
showMainMenu.set(menuWrap, { display: "flex" });
showMainMenu.set(menuOverlay, { display: "block" });
showMainMenu.to(menuOverlay, { opacity: 1 });
showMainMenu.to(menuWrap, { x: "0%" });
showMainMenu.to(menuIcon, { transform: "scale3d(1, 0.1, 1)" }, "<");
menuIcon.on("click", function () {
  showMainMenu.play();
  /* lenis.stop(); */
});
$(".sub-menu_selector").on("click", function () {
  $(this).closest(".sub-menu_toggle").addClass("is-open");
});
$(".menu-back").on("click", function () {
  $(".sub-menu_toggle").removeClass("is-open");
});
menuOverlay.on("click", function () {
  showMainMenu.reverse();
});
$(document).on("keydown", function (e) {
  if (e.key === "Escape") showMainMenu.reverse();
});
closeMenu.on("click", function () {
  showMainMenu.reverse();
  /* lenis.start(); */
});
backButton.on("click", function () {
  showSubMenu.reverse();
});

// //NAV SHRINK
// mm.add("(max-width: 767px)", () => {
//   let navShrink = gsap.timeline({
//     scrollTrigger: {
//       trigger: ".page-wrap",
//       start: "top top",
//       end: "top -300px",
//       scrub: true,
//     },
//   });
//   navShrink.to(".logo-img", {
//     opacity: 0,
//     ease: "linear",
//   });
//   navShrink.to(".nav", {
//     paddingTop: "0px",
//     paddingBottom: "0px",
//     ease: "linear",
//   });
//   navShrink.to(
//     ".logo-icon",
//     {
//       opacity: 1,
//       ease: "linear",
//     },
//     "<",
//   );
// });
